<template>
  <div>
    <el-select :disabled="disabled" :size="size" v-model="value" filterable remote placeholder="请输入名称" :remote-method="remoteMethod" :loading="loading" @change="handleChange" clearable style="display: block">
      <el-option v-for="(item, index) of options" :key="index" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'componentsEmployeeSelect',
  model: {
    prop: 'id',
    event: 'change'
  },
  props: {
    id: {
      type: [String, Number]
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    id: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.value = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      value: '',
      options: []
    };
  },
  methods: {
    // 选择
    handleChange() {
      this.$emit('change', this.value);
    },
    //远程搜索
    async remoteMethod(query) {
      await this.$api.employee.list({ keyword: query.trim() }).then(res => {
        if (res.code != 200 || !res.data) return;
        this.options = res.data.list;
      });
    },
    // 获取数据
    async getData() {
      let params = { page_size: 200 };
      await this.$api.employee.list(params).then(res => {
        if (res.code == 200) {
          this.options = res.data.list;
        }
      });
    }
  }
};
</script>
